shouldWriteResult